import {Component, createElement} from "react";
import {Fab} from "@material-ui/core";
import {MailIcon} from "../icons";
import customTheme from "../theme";

interface SendFabProps {
    onClick: () => void
}

export class SendFab extends Component<SendFabProps> {

    render() {
        return(
            <Fab color="primary" aria-label="edit"
                 style={{
                     position: 'fixed',
                     bottom: customTheme.spacing(8),
                     right: customTheme.spacing(3)
                 }}
                 onClick={this.props.onClick}>
                <MailIcon />
            </Fab>
        );
    }
}
